// Executa `tarefa(item, indice)` para cada item, com no MÁXIMO `limite` tarefas ao mesmo tempo.
// Motivo (24/09/2026, U26): "Salvar & Organizar" disparava N chamadas ao backend do Render
// ao mesmo tempo (Promise.all). Com ~100 anexos, isso estoura tempo/limite e deixa a
// numeração MISTA (parte 07, parte 007). Função pura: sem React, sem rede.
//
// Devolve um array na MESMA ordem dos itens. Se a tarefa lançar erro, o resultado daquele
// item vira `false` (não derruba as demais).
export async function executarComLimite(itens, limite, tarefa) {
  const lista = Array.isArray(itens) ? itens : [];
  const maximo = Math.max(1, Math.floor(Number(limite)) || 1);
  const resultados = new Array(lista.length);
  let proximo = 0;

  const trabalhador = async () => {
    for (;;) {
      const i = proximo;
      proximo += 1;
      if (i >= lista.length) return;
      try {
        resultados[i] = await tarefa(lista[i], i);
      } catch {
        resultados[i] = false;
      }
    }
  };

  await Promise.all(Array.from({ length: Math.min(maximo, lista.length) }, trabalhador));
  return resultados;
}
